<template>
  <modal
    class="addNewRetainershipModal"
    name="addBRLModal"
    transition="pop-out"
    :width="modalWidth"
    :height="370"
    @closed="closed"
    @opened="opened"
  >
    <div class="retainership__box">
      <button
        type="button"
        class="close modal-close"
        aria-label="Close"
        @click="closed"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="text-center">
        <h3 class="mt-2 add__retainership__header">
          <span>
            <img src="@/assets/img/deal.png" width="50px" />
          </span>
          <span>
            {{ $t("text.reorderLevel.addRe") }}
          </span>
        </h3>

        <div class="sign_up_form_section">
          <form>
            <div class="mt-3 form_input_section">
              <div class="mt-3 input__block">
                <select v-model="product" @change="getProductCapacity">
                  <option value="selectProduct" selected disabled>
                    {{ $t("text.priceManagement.selectProduct") }}
                  </option>
                  <option
                    :value="product.id"
                    v-for="(product, index) in productList"
                    :key="index"
                  >
                    <span>
                      {{ product.productName }}
                    </span>
                  </option>
                </select>
              </div>
              <!-- <img
                src="@/assets/img/git_loader.gif"
                style="display: none"
                width="10px"
                class="ml-3 loader2 d-flex justify-content-start"
              /> -->
              <label
                v-if="showProCap"
                class="text-success d-flex justify-content-start"
                >{{ $t("text.reorderLevel.proCap") }}:
                {{ productCapacity }}</label
              >
            </div>

            <div class="mt-3 form_input_section">
              <label class="d-flex justify-content-start" for="">{{
                $t("text.reorderLevel.title")
              }}</label>
              <div class="input__block" ref="phone_input_div">
                <input
                  type="number"
                  :placeholder="$t('text.reorderLevel.title')"
                  class="form-control w-100"
                  v-model="reorderLevel"
                />
              </div>
            </div>

            <div class="mt-5 text-center">
              <button
                class="btn dealers_btn"
                @click="addBRL"
                :disabled="isButtonDisabled ? true : null"
                :style="[
                  isButtonDisabled
                    ? { cursor: 'not-allowed' }
                    : { cursor: 'pointer' },
                ]"
              >
                {{ $t("text.cDrystock.add") }}
                <img
                  src="@/assets/img/git_loader.gif"
                  style="display: none"
                  width="19px"
                  class="ml-3 loader"
                />
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
const MODAL_WIDTH = 700;
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "addBRLModal",
  props: ["industryBranchId"],
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      isButtonDisabled: false,
      showLoader: false,
      reorderLevel: 0,
      product: "selectProduct",
      productCapacity: "",
      showProCap: false,
      productList: [],
    };
  },
  // watch: {
  //   companyId(oldValue, newValue) {
  //     this.getCompanyBranchDealers();
  //   },
  // },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  methods: {
    opened() {
      this.getProducts();
    },
    closed() {
      this.reorderLevel = 0;
      this.product = "selectProduct";
      this.$modal.hide("addBRLModal");
      this.showProCap = false;
    },

    getProducts() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Products/Branch/${this.industryBranchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.productList = response.data;
          // console.log(response);
        })
        .catch((error) => {
          // this.showLoader = false;
        });
    },

    getProductCapacity() {
      // $(".loader2").show();
      this.showProCap = false;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Products/ProductCapacity?Id=${this.product}&BranchId=${this.industryBranchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          // $(".loader2").hide();
          this.showProCap = true;
          this.productCapacity = response.data.totalCapacity;
          // console.log(response);
        })
        .catch((error) => {
          // this.showLoader = false;
        });
    },

    addBRL(event) {
      event.preventDefault();

      if (this.product == "selectProduct") {
        this.$toast.open({
          message: this.$t("text.reorderLevel.selPro"),
          type: "error",
          duration: 3000,
        });
        return;
      }

      if (!this.reorderLevel) {
        this.$toast.open({
          message: this.$t("text.reorderLevel.inputRL"),
          type: "error",
          duration: 3000,
        });
        return;
      }

      $(".loader").show();
      this.isButtonDisabled = true;

      const data = {
        reorderLevel: parseFloat(this.reorderLevel),
        productId: parseFloat(this.product),
        branchId: this.industryBranchId,
      };

      this.axios
        .post(
          `${configObject.apiBaseUrl}/Products/ProductReorderLevels/Create`,
          data,
          configObject.authConfig()
        )
        .then((res) => {
          this.$toast.open({
            message: this.$t("text.products.added"),
            type: "success",
            duration: 3000,
          });

          $(".loader").hide();
          this.isButtonDisabled = false;
          this.product = "";
          this.reorderLevel = 0;
          this.$modal.hide("addBRLModal");
          this.$eventHub.$emit("getBRL");
        })
        .catch((error) => {
          this.isButtonDisabled = false;
          $(".loader").hide();
          this.$toast(error.response.data.message, {
            type: "error",
            timeout: 3000,
          });
        });
    },
  },
};
</script>
